function normalizeGender(gender) {
  const value = (gender || "").toLowerCase().trim();
  if (value === "male") return "male";
  if (value === "female") return "female";
  return "other";
}

function pct(part, total) {
  return total ? Math.round((part / total) * 100) : 0;
}

export function computeAdminDashboardStats(users) {
  const list = Array.isArray(users) ? users : [];
  const total = list.length;

  let male = 0;
  let female = 0;
  let otherGender = 0;
  let complete = 0;
  let incomplete = 0;
  let verified = 0;
  let unverified = 0;
  let withBio = 0;
  let withPhotos = 0;
  let ageSum = 0;
  let ageCount = 0;
  const countryCounts = {};

  list.forEach((user) => {
    const gender = normalizeGender(user.gender);
    if (gender === "male") male += 1;
    else if (gender === "female") female += 1;
    else otherGender += 1;

    if (user.isProfileComplete) complete += 1;
    else incomplete += 1;

    if (user.isVerified || user.verified) verified += 1;
    else unverified += 1;

    if ((user.bio || "").trim()) withBio += 1;
    if (Array.isArray(user.images) && user.images.length > 0) withPhotos += 1;

    const age = Number(user.age);
    if (Number.isFinite(age) && age > 0) {
      ageSum += age;
      ageCount += 1;
    }

    const country = (user.country || "").trim();
    if (country) {
      countryCounts[country] = (countryCounts[country] || 0) + 1;
    }
  });

  const topCountries = Object.entries(countryCounts)
    .sort((a, b) => b[1] - a[1])
    .slice(0, 6)
    .map(([name, count]) => ({ name, count, pct: pct(count, total) }));

  const healthScore = total
    ? Math.min(
        100,
        Math.round(
          pct(complete, total) * 0.35 +
            pct(verified, total) * 0.15 +
            pct(withPhotos, total) * 0.3 +
            pct(withBio, total) * 0.2
        )
      )
    : 0;

  let healthLabel = "Needs attention";
  let healthTone = "orange";
  if (healthScore >= 75) {
    healthLabel = "Healthy";
    healthTone = "green";
  } else if (healthScore >= 50) {
    healthLabel = "Fair";
    healthTone = "yellow";
  }

  return {
    total,
    male,
    female,
    otherGender,
    complete,
    incomplete,
    verified,
    unverified,
    withBio,
    withPhotos,
    avgAge: ageCount ? Math.round(ageSum / ageCount) : null,
    topCountries,
    pctComplete: pct(complete, total),
    pctVerified: pct(verified, total),
    pctWithPhotos: pct(withPhotos, total),
    pctWithBio: pct(withBio, total),
    pctMale: pct(male, total),
    pctFemale: pct(female, total),
    healthScore,
    healthLabel,
    healthTone,
  };
}
